module.exports = __webpack_public_path__ + "img/4386-connection-error.88489a36.gif";